import { useState, useEffect } from "react";
import AIheader from '../../RentAI/AIheader';
import Footer from '../../../Component/Footer/Footer';
import Getstarted from "../../../Component/GetStarted/Getstarted";
import BetaWaitlist from "../../../Component/Beta-Waitlist/BetaWaitlist"
import './AirbnbHosts.css';
 

const AirbnbHosts = () => {
    const [showWaitlist, setShowWaitlist] = useState(false);
    const [showGetstarted, setShowGetstared] = useState(false);

    const [activeIndex, setActiveIndex] = useState(0);
    
    const menuItems = [
        { id: "airbnb_turo_hosts_1", text: "The Power of Owning Your Brand—On and Off Airbnb" },
        { id: "airbnb_turo_hosts_2", text: "Why Add Car Rentals to Your Guest Experience?" },
        { id: "airbnb_turo_hosts_3", text: "Rentid: Everything You Need to Run Your Car Rental Business" },
        { id: "airbnb_turo_hosts_4", text: "Three Easy Ways to Get Started" },
        { id: "airbnb_turo_hosts_5", text: "Simple, Transparent Pricing" },
        { id: "airbnb_turo_hosts_6", text: "Run It Like a Business. Own It Like a Brand." },
    ];

    useEffect(() => {
        const handleScroll = () => {
            let scrollPosition = window.scrollY - 400; // Adjust offset for better accuracy
            let foundIndex = 0;

            menuItems.forEach((item, index) => {
                const section = document.getElementById(item.id);
                if (section) {
                    const offsetTop = section.offsetTop;
                    if (scrollPosition >= offsetTop) {
                        foundIndex = index;
                    }
                }
            });

            setActiveIndex(foundIndex);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [menuItems, setActiveIndex]);

    return (
        <>
<AIheader/>
<Getstarted
showJoinWaitList={showGetstarted}
onClose={() => setShowGetstared(false)}
onOpen={() => setShowGetstared(true)}
/>
 
{/* START maxBannerMain */}
<section className="maxBannerMain airbnbTuroHostsBannerMain">
    <div className="maxBannerOuter">
        <div className="container">
            <div className='row align-items-center'>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                    <div className='maxBannerLeft'>
                        {/* <div className="blogHeadingInner">
                            <img width="17px" src="/img/blog/blog_icon_blue.svg" alt="icon"/>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/blogs">Blog</a></li>
                                    <img width="" src="/img/arrow-right-nav.svg" alt="rent id"/>
                                    <li className="breadcrumb-item active" aria-current="page">Article 006</li>
                                </ol>
                            </nav>
                        </div> */}
                        <small>Vacation Rental</small>
                        <h2>How Airbnb Hosts Can Offer Car Rentals with Rentid</h2>
                        {/* <p>Published: Apr 13, 2025</p>
                        <p><span>Estimated Reading Time: 5 mins</span></p> */}

                        <div className="blogHeadingDetails">
                            <figure>
                                <img width="42" src="/img/blog/r_logo.svg" alt="icon"/>
                            </figure>
                            <ul>
                                <li>Editorial Team</li>
                                <li>May 13, 2025</li>
                                <li>5 min read</li>
                            </ul>
                        </div>
                      
                        <button onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</button>
                    </div>
                </div>
            </div>
        </div>
        <div className='maxBannerRight'>
            <figure>
                <img  src="/img/blog/airbnbTuroHostsBanner.png" alt="blog" />
            </figure>
        </div>
    </div>
</section>
{/* END maxBannerMain */}
 

{/* START maxBannerMain */}
<section className="choosePhotoMain">
    <div className="container">
        <div className='row'>
            <div className='col-lg-3 col-md-3 col-sm-12'>
                <div className='choosePhotoLeft'>
                    <ul>
                        {menuItems.map((item, index) => (
                            <li 
                                key={item.id} 
                                className={index === activeIndex ? "active" : ""}
                                onClick={() => setActiveIndex(index)}
                            >
                                <a href={`#${item.id}`}>{item.text}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className='col-lg-9 col-md-9 col-sm-12'>
                <div className='choosePhotoRight'>
                    <div className='choosePhotoTop'>
                        <p><strong>You’ve built a great brand on Airbnb—now you can extend it with your own car rental business. </strong>
                        Whether you host one property or manage multiple listings, your guests need more than a place to stay—they 
                        need a way to get around. With Rentid, you can offer car rentals directly to your guests and <strong>build a 
                        travel experience that’s 100% yours.</strong></p>
                        <img className="img-fluid airbnb_turo_hosts_image" width="568" src="/img/blog/vacation_banner.webp" alt="rent id"/>
                        <div className='gradientBlogData'>
                            <h3>TL;DR</h3>
                            <p><strong>Rentid unlocks a powerful new revenue stream for Airbnb hosts: on-brand car 
                                rentals</strong>, fully controlled and seamlessly integrated with their guest experience. With 
                                built-in insurance, automation, and smart booking tools, Rentid transforms listings into 
                                full-scale hospitality businesses<strong>—giving hosts the power to own the journey, 
                                not just the stay.</strong></p>
                        </div>
                    </div>

                    <div className='choosePhotoData' id='airbnb_turo_hosts_1'>
                        <h2>The Power of Owning Your Brand—On and Off Airbnb</h2>
                        <p>Airbnb have helped hosts like you connect with travelers—but they keep control over the 
                            experience, the policies, and the revenue flow. With Rentid, you get the tools to build <strong>your own 
                            rental business</strong> that works alongside these platforms—or entirely outside of them.</p>
                            
                        <p>Your properties/vehicles aren’t just listings. Together, they’re a brand. Rentid helps you 
                            bring that brand to life with a professional setup, smart automation, and full protection—<strong>so 
                            you can create consistent, premium experiences across both stays and rides.</strong></p>
                    </div>

                    <div className='choosePhotoData' id='airbnb_turo_hosts_2'>
                        <h2>Why Add Car Rentals to Your Guest Experience?</h2>
                        <ul>
                            <li><strong>Travelers prefer one-stop convenience—</strong>renting a car where they book their stay saves time and adds value.</li>
                            <li>Airbnb saw <strong>75M+ app downloads in 2024</strong> , and the travel industry saw <strong>70%+ of revenue come from online bookings.</strong></li>
                            <li>Your guests are already renting—now you can <strong>offer more and earn more</strong> on every reservation</li>
                            <li>Instead of losing guests to off-site rental companies, <strong>keep everything under your brand and under your control</strong></li>
                        </ul>
                        <img className="img-fluid airbnb_turo_hosts_2" src="/img/blog/airbnb_turo_hosts_2.webp" alt="rent id"/>
                    </div>

                    <div className='choosePhotoData' id='airbnb_turo_hosts_3'>
                        <h2>Rentid: Everything You Need to Run Your Car Rental Business</h2>
                        <p><strong>We built Rentid to empower hosts</strong>—whether you're adding a single car or building a fleet. Our platform includes:</p>
                      

                        <p><strong><a href='/rentshield'>RentShield™</a> — On-Rent Insurance, Done Right</strong></p>
                        <ul>
                            <li>Daily-use <a href='/rentshield#CommercialAutoInsurance'>insurance</a> that activates only when your car is on rent</li>
                            <li><a href='/rentshield#GuestProtectionPlans'>Liability-only or Comprehensive plans</a> with coverage up to $110,000 ACV</li>
                            <li><a href='/rentshield#NationalRoadsideAssistance'>Roadside assistance</a> and support included</li>
                            <li>Customizable protection plans to upsell to guests</li>
                            <li>Full <a href='/rentsuccess#ResolutionCenter'>Resolution Center</a> to handle claims, tolls, tickets, and violations</li>
                            <li>With Rentid, you don’t need a commercial policy—<strong>we’ve got you covered.</strong></li>
                        </ul>

                        <p><strong><a href='/rent-id'>RentID™</a> — Smart Driver Screening</strong></p>
                        <p>Each guest is automatically screened through:</p>
                        <ul>
                            <li>AI-based <a href='/rent-id#guestverification'>ID verification</a></li>
                            <li><a href='/rent-id#AutoInsuranceValidation'>Auto insurance validation</a> (where applicable) </li>
                            <li>Proprietary <a href='/rent-id#DriverIQScore'>DriverIQ™</a> scoring system</li>
                            <li>A <a href='/rent-id#NationalBlockListDatabase'>national “Do Not Rent” list</a> to screen risky drivers</li>
                            <li>Know who you’re renting to <strong>before you hand over the keys.</strong></li>
                        </ul>

                        <p><strong><a href='/rentdirect'>RentDirect™</a> — Your Own Booking Engine</strong>.</p>
                        <ul>
                            <li>Add booking links to Airbnb, Instagram, or email follow-ups</li>
                            <li>Accept bookings instantly or manually</li>
                            <li>Offer delivery, set custom pickup/drop-off locations</li>
                            <li>Customize rates, mileage, cancellation, and policies</li>
                            <li>Works seamlessly with your existing calendar and pricing logic</li>
                            <li>You’re not listing on a marketplace—you’re running your own.</li>
                        </ul>

                        <p><strong><a href='/rentai'>RentAI™</a> — Automation That Works For You</strong>.</p>
                        <p>Let RentAI take care of:</p>
                        <ul>
                            <li>FAQs and guest support</li>
                            <li>Smart pricing and reminders</li>
                            <li>Trip scheduling and vehicle availability</li>
                            <li><a href='/rentdirect#fleettab4'>Telematics</a> integration (optional)</li>
                            <li>Alerts and violation tracking</li>
                        </ul>
                        <p><strong>Your business runs 24/7—even if you’re offline.</strong></p>
                    </div> 

                    <div className='choosePhotoData' id='airbnb_turo_hosts_4'>
                        <h2>Three Easy Ways to Get Started</h2>
                        <img className="img-fluid airbnb_turo_hosts_4" src="/img/blog/airbnb_turo_hosts_4.webp" alt="rent id"/>
                        <p><strong>No dev work, no hassle. Choose the setup that works for you:</strong></p>
                        
                        <p><strong>1. Simple Booking Link</strong></p>
                        <p>Add a direct link to your car rental listing anywhere—Airbnb messages, your Instagram bio, email, or your welcome book.</p>    

                        <p><strong>2. Embed On Your Existing Website</strong></p>
                        <p>Already have a site for your property or brand? Just drop in our embed code to display your vehicles, pricing, and booking system.</p>   

                        <p><strong>3. Get a Free Website from Rentid</strong></p>
                        <p>No site? No problem. We’ll generate a <a href='/rentdirect#BrandedDigitalExperiences'>fully branded car rental website</a> for your business—including:</p>    
                        <ul>
                            <li>Your logo, name, and contact info</li>
                            <li>Booking and payment flows</li>
                            <li>Protection plans, terms, and custom offers</li>
                        </ul>
                        <p>No tech skills required. Your guests will see a <strong>sleek, professional site that reflects your brand—not ours.</strong></p>   
                    </div>




                    <div className='choosePhotoData' id='airbnb_turo_hosts_5'>
                        <h2>Simple, Transparent Pricing</h2>
 
                        <ul>
                            <li><strong>Free to start. No credit card required.</strong></li>
                            <li><strong>Monthly subscription</strong> includes <strong>unlimited rentals</strong> and <strong>roadside assistance</strong></li>
                            <li><strong>Insurance charges</strong> are billed <strong>per-day</strong> and can 
                            be <strong>baked into the guest experience</strong></li>
                            <li><strong>No commission on bookings,</strong> and <strong>you set all your rates</strong></li>
                        </ul>
                        <p>We’ve removed the friction <strong>so you can build your brand, not someone else’s.</strong></p>
                    </div>

                    <div className='choosePhotoData' id='airbnb_turo_hosts_6'>
                        <h2>Run It Like a Business. Own It Like a Brand.</h2>
                        <p>This isn’t a side hustle— <strong>it’s your business.</strong></p> 
                        <p><strong>Rentid gives you everything you need</strong> to offer car rentals under your name, your pricing, and your terms. Build trust. 
                            Keep revenue. <strong>Deliver value from the driveway to the doormat</strong></p>   
              
                        <img className="img-fluid airbnb_turo_hosts_6" src="/img/blog/airbnb_turo_hosts_6.webp" alt="rent id"/>
                        
                        
                        <div className='logoBlog'>
                                <img className="img-fluid rent_id_logo" src="/img/blog/rent_id_logo.svg" alt="rent id"/> 
                            <p>Editorial Team</p> 
                        </div>

                        <div className='blackBlogData'>
                            <div className='blackBlogDataLeft'>
                                <h3>Own the Full Guest Journey. Build the Future of Travel.</h3>
                                <p>You’ve built a trusted stay—now scale your brand with on-demand car rentals powered by Rentid. From insurance to automation, our all-in-one platform gives you full control, higher revenue, and total hospitality ownership.</p>
                                <small>Start for free and only pay when you get <span>rentid</span></small>
                            </div>
                            
                            <div className='blackBlogDataRight'> 
                                <BetaWaitlist
                                    showJoinWaitList={showWaitlist}
                                    onClose={() => setShowWaitlist(false)}
                                    onOpen={() => setShowWaitlist(true)}
                                />

                                <button onClick={() => setShowWaitlist(true)} className="btn">
                                    Join The Waitlist
                                </button>
                            </div>
                        </div>

                        <div className='blogSocial'>
                        <div className='row'>
                            <div className='col-lg-9'>
                                <div className='blogSocialLeft'>
                                    <p>Spread the word—this one’s worth sharing</p>
                                </div>
                            </div>
                            <div className='col-lg-3'>
                                <div className='blogSocialRight'>
                                    <ul>
                                        <li>
                                            <a href="#">
                                                <img className="img-fluid" src="/img/blog/linkedin.svg" alt="linkedin"/> 
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <img className="img-fluid" src="/img/blog/facebook.svg" alt="facebook"/> 
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <img className="img-fluid" src="/img/blog/twitter.svg" alt="twitter"/> 
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <img className="img-fluid" src="/img/blog/link.svg" alt="link"/> 
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        </div>

                       
                    </div>
 
                </div> 
            </div>
        </div>
    </div>
 
</section>
{/* END maxBannerMain */}


<Footer/>
        </>
    )
}

export default AirbnbHosts;